var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_24959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1829 7.54183C16.3079 3.69183 12.9496 1.9585 9.99959 1.9585C9.99959 1.9585 9.99959 1.9585 9.99126 1.9585C7.04959 1.9585 3.68292 3.6835 2.80792 7.5335C1.83292 11.8335 4.46626 15.4752 6.84959 17.7668C7.73292 18.6168 8.86626 19.0418 9.99959 19.0418C11.1329 19.0418 12.2663 18.6168 13.1413 17.7668C15.5246 15.4752 18.1579 11.8418 17.1829 7.54183ZM9.99959 11.7168C8.54959 11.7168 7.37459 10.5418 7.37459 9.09183C7.37459 7.64183 8.54959 6.46683 9.99959 6.46683C11.4496 6.46683 12.6246 7.64183 12.6246 9.09183C12.6246 10.5418 11.4496 11.7168 9.99959 11.7168Z",
    fill: "#7C7C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_24959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFill);
export default __webpack_public_path__ + "static/media/location-fill.8007a9b5daf4c7060dedbeb454cb39ac.svg";
export { ForwardRef as ReactComponent };